// If query param is present in URL, this can be used to toggle logging
export function hasDisplayAdsDebugQuery() {
    try {
        const queryParams: any = new Proxy(
            new URLSearchParams(window.location.search),
            {
                get: (searchParams, prop) => searchParams.get(prop as string),
            },
        );

        return queryParams.displayads_debug;
    } catch (e) {
        return false;
    }
}

export function displayAdsLog(log: any, ...optionalParams: any[]) {
    if (hasDisplayAdsDebugQuery()) {
        console.warn(
            'displayads-podlet-horseshoe:   ' + JSON.stringify(log),
            optionalParams,
        );
    }
}
